import Vue from 'vue'
import AscSwitch from '@/components/atoms/AscSwitch'
import AscTooltip from '@/components/atoms/AscTooltip'
import AscLabel from '@/components/atoms/AscLabel'

import {
  CUSTOM_ALERT_FULL_FLIGHT_DATA_ID,
  CUSTOM_ALERT_SNAPSHOT_DATA_ID,
  ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID,
  ADVANCED_CUSTOM_ALERTS_DPLF_DATA_ID,
  CUSTOM_ALERT_FULL_FLIGHT_ACTIVE_ALERT_LIMIT,
} from '@/utilities/appConsts'

export default Vue.extend({
  components: {
    AscSwitch,
    AscTooltip,
    AscLabel,
  },

  data() {
    return {
      activeState: false,
      disabled: false,
      readonly: false,
      CUSTOM_ALERT_FULL_FLIGHT_DATA_ID,
      CUSTOM_ALERT_SNAPSHOT_DATA_ID,
      ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID,
      ADVANCED_CUSTOM_ALERTS_DPLF_DATA_ID,
    }
  },

  created() {
    this.data = this.params.data
    this.label = ''
    this.id = this.params.data.baseAlertId
    this.value = this.params.data.isEnabled

    if (this.data.customAlertTypeId === ADVANCED_CUSTOM_ALERTS_DPLF_DATA_ID) {
      const trivialCheck =
        this.data.aircraftIds.length > 0 &&
        this.data.persistenceFrom <= this.data.persistenceTo &&
        this.data.validLogic
      this.params.data.inErrorState = !trivialCheck
    }
    this.inErrorState = this.params.data.inErrorState
      ? this.params.data.inErrorState
      : false
    this.activeState = this.params.data.isEnabled
    this.dataSource = this.params.data.dataSource
    this.customAlertTypeId = this.params.data.customAlertTypeId
    this.disabled = this.params.disabled || false
    this.readonly = this.params.readonly
  },

  methods: {
    isDisabled() {
      if (
        this.readonly ||
        (!this.activeState &&
          this.params.data.fullFlightActiveCount >=
            CUSTOM_ALERT_FULL_FLIGHT_ACTIVE_ALERT_LIMIT &&
          (this.customAlertTypeId === CUSTOM_ALERT_FULL_FLIGHT_DATA_ID ||
            this.customAlertTypeId ===
              ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID ||
            this.customAlertTypeId === ADVANCED_CUSTOM_ALERTS_DPLF_DATA_ID))
      ) {
        this.disabled = true
      }
      return this.disabled
    },

    toggleSwitch(value) {
      this.activeState = value
      this.params.callback({
        name: this.params.data.name,
        acmfReportNumberId: this.params.data.acmfReportNumberId
          ? this.params.data.acmfReportNumberId
          : null,
        ruleDefinitionJson: this.params.data.ruleDefinitionJson,
        customAlertTypeId: this.params.data.customAlertTypeId,
        airlineId: this.params.data.airlineId,
        isEnabled: value,
        id: this.params.data.baseAlertId,
        aircraftIds: this.params.data.aircraftIds,
        ataChapters: this.params.data.ataChapters,
        recAction: this.params.data.recAction,
        isShared: this.params.data.isShared,
        partNumberIds: this.params.data.partNumberIds,
      })
    },

    getTooltipString() {
      if (this.params?.data?.inErrorState) {
        return `Fix all errors to activate custom analytic.`
      } else if (
        !this.activeState &&
        (this.customAlertTypeId === CUSTOM_ALERT_FULL_FLIGHT_DATA_ID ||
          this.customAlertTypeId ===
            ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID ||
          this.customAlertTypeId === ADVANCED_CUSTOM_ALERTS_DPLF_DATA_ID) &&
        this.disabled
      ) {
        return `You have reached your limit of ${CUSTOM_ALERT_FULL_FLIGHT_ACTIVE_ALERT_LIMIT} Full Flight/DPLF Data Custom Analytics.`
      }
    },
    getOnOff(activeState) {
      if (activeState) {
        return 'On'
      } else {
        return 'Off'
      }
    },
  },

  template: `<div>
  <span class="asc-customAlerts--gridDraftText" v-if="value === null && !inErrorState">Draft</span>
  <asc-tooltip :key="1" left nudge-left="20" position-y="10" :tooltip="getTooltipString()" :tooltip-length="0">
     <asc-switch
        v-if="value !== null && !readonly"
        :label="label"
        :value="activeState"
        :disabled="(this.params.data.inErrorState || (!activeState && this.isDisabled() && (customAlertTypeId === CUSTOM_ALERT_FULL_FLIGHT_DATA_ID || customAlertTypeId === ADVANCED_CUSTOM_ALERTS_FULL_FLIGHT_DATA_ID || customAlertTypeId === ADVANCED_CUSTOM_ALERTS_DPLF_DATA_ID)))"
        @input="toggleSwitch"
        ></asc-switch>
      <div v-else>
        <asc-label style="padding-bottom: 4px;" size="sm" :value="getOnOff(activeState)"></asc-label>
      </div>
  </asc-tooltip>
</div>`,
})
